import { Paper, styled } from '@mui/material';

export const SectionContainerItem = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '10px',
  textAlign: 'left',
  padding: '16px',
  display: 'flex',
  columnGap: '12px',
  alignItems: 'center',
}));

SectionContainerItem.defaultProps = {
  elevation: 0,
};
